import { useAsyncData, useRoute } from '#imports'
import { computed } from 'vue'

import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

import { transformReviewsResponse } from '~/scopes/reviews/reviews-display/utils/transformReviewsResponse'

export function useProductListReviews(id: string) {
  const route = useRoute()
  const locale = useI18nLocale()
  const $httpFetch = useHttpFetch()

  const queryParams = computed(() => {
    return {
      order_by: '-relevance_alt',
      ...route.query,
      translation_locale: locale,
    }
  })

  return useAsyncData(
    computed(() =>
      getAsyncDataKey('product-reviews', { id, ...queryParams.value }),
    ),
    () =>
      $httpFetch('/reviews/v1/product-landings/:uuid/products/reviews', {
        pathParams: { uuid: id },
        query: queryParams.value,
      }),
    {
      transform: (response) => ({
        previousCursor: response.previousCursor,
        nextCursor: response.nextCursor,
        results: transformReviewsResponse(response.results),
      }),
    },
  )
}
